// https://www.webtips.dev/react-contact-form-without-backend

import React from "react";
import ContactForm from "../components/ContactForm";
import "bootstrap/dist/css/bootstrap.min.css";

function Contact() {
	return (
		<div className="ContactFormClass">
			<ContactForm />
		</div>
	);
}

export default Contact;
